import { createFeatureSelector, createSelector } from "@ngrx/store";
import { LightingState } from "./lighting.entity";
import { themesSelectors } from "./themes/theme.reducer";
import { sceneSelectors } from "./scenes/scene.reducer";
import { sceneScheduleSummarySelectors, scenesStatusSelectors, themesStatusSelectors } from './lighting.reducer';
import { themeScheduleSummarySelectors } from "./theme-schedule-summary/theme-schedule-summary.reducer";
import { cctColorSelectors } from "./cct-color/cct-color.reducers";
import { rgbColorSelectors } from "./rgb-color/rgb-color.reducers";
import { ThemesStatusState } from "./themes-status/themes-status.entity";

export const lightingFeatureSelector = createFeatureSelector<LightingState>('lightingState');


export const getThemeState = createSelector(
    lightingFeatureSelector,
    (state: LightingState) => state.themes
);

export const getThemeStatusState = createSelector(
    lightingFeatureSelector,
    (state: LightingState) => state.themesStatus
);

export const getSceneState = createSelector(
    lightingFeatureSelector,
    (state: LightingState) => state.scenes
);

export const getSceneStatusState = createSelector(
    lightingFeatureSelector,
    (state: LightingState) => state.scenesStatus
);

export const getCCTColorState = createSelector(
    lightingFeatureSelector,
    (state: LightingState) => state.cctColors
)

export const getRGBColorState = createSelector(
    lightingFeatureSelector,
    (state: LightingState) => state.rgbColors
)

export const getThemeScheduleSummaryState = createSelector(
    lightingFeatureSelector,
    (state: LightingState) => state.themeScheduleSummaryList
);

export const getSceneScheduleSummaryState = createSelector(
    lightingFeatureSelector,
    (state: LightingState) => state.sceneScheduleSummaryList
);



export const getThemeEntities = createSelector(
    getThemeState,
    themesSelectors.selectEntities
);

export const getAllThemes = createSelector(
    getThemeState,
    themesSelectors.selectAll
);

export const getNewlyCreatedTheme = createSelector(
    getThemeState,
    state => state.newlyCreatedTheme
)

export const getAllThemesStatus = createSelector(
    getThemeStatusState,
    themesStatusSelectors.selectAll
);

export const getSceneEntities = createSelector(
    getSceneState,
    sceneSelectors.selectEntities
);

export const getAllScenes = createSelector(
    getSceneState,
    sceneSelectors.selectAll
);

export const getSceneStatusEntities = createSelector(
    getSceneStatusState,
    scenesStatusSelectors.selectEntities
);

export const getAllScenesStatus = createSelector(
    getSceneStatusState,
    scenesStatusSelectors.selectAll
);

export const getSceneScheduleSummaryEntities = createSelector(
    getSceneScheduleSummaryState,
    sceneScheduleSummarySelectors.selectEntities
);

export const getAllSceneScheduleSummary = createSelector(
    getSceneScheduleSummaryState,
    sceneScheduleSummarySelectors.selectAll
)

export const getThemeScheduleSummaryEntities = createSelector(
    getThemeScheduleSummaryState,
    themeScheduleSummarySelectors.selectEntities
);

export const getAllThemeScheduleSummary = createSelector(
    getThemeScheduleSummaryState,
    themeScheduleSummarySelectors.selectAll
);

export const cctColors = createSelector(
    getCCTColorState,
    cctColorSelectors.selectAll
);

export const rgbColors = createSelector(
    getRGBColorState,
    rgbColorSelectors.selectAll
);
